// Redux
import { Dispatch } from "redux";

// Classes
import {
  USA,
  International,
  GeographyReducerState
} from "../classes/geography.classes";

// Constants
import {
  US_REGIONS,
  US_STATES_AND_TERRITORIES
} from "../constants/geography.constants";

// Action Creators
import {
  setUSA,
  setInternational,
  setGeographyState
} from "../actionCreators/geography.actionCreators";

export const setUSAValue = (
  dispatch: Dispatch<any>,
  usa: USA,
  value: any,
  identifier: "selectionUSA" | "value"
) => {
  let newUSA: USA;

  if (identifier === "selectionUSA") {
    newUSA = {
      ...usa,
      selection: value
    };
    if (usa.selection !== value) {
      newUSA.value = [];
    }
  } else {
    newUSA = {
      ...usa,
      value: value
    };
  }

  dispatch(setUSA(newUSA));
};

export const setInternationalValue = (
  dispatch: Dispatch<any>,
  international: International,
  value: any,
  identifier: "selectionInternational" | "value"
) => {
  let newInternational: International;

  if (identifier === "selectionInternational") {
    newInternational = {
      ...international,
      selection: value
    };
    if (international.selection !== value) {
      newInternational.value = [];
    }
  } else {
    newInternational = {
      ...international,
      value: value
    };
  }

  dispatch(setInternational(newInternational));
};

export const initializeGeographyState = (
  dispatch: Dispatch<any>,
  state: GeographyReducerState
) => {
  dispatch(setGeographyState(state));
};
